import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Sayıyı Türkçe binlik ayracıyla göster (1001994 → "1.001.994"). Kredi/adet gösterimlerinde kullan.
// Bazı kartlarda product_image_url gerçek URL değil, işaret metnidir ("freeform", "promo-auto"…).
// Görsel basmadan önce bununla kontrol et — kırık foto sembolü yerine placeholder gösterilir.
export function isRealImageUrl(u: string | null | undefined): boolean {
  return !!u && /^https?:\/\//i.test(u);
}

export function fmtTR(n: number | null | undefined): string {
  return (Number(n) || 0).toLocaleString("tr-TR");
}

// TR cep telefonu — ham girdiden temiz 10 hane: baştaki +90/0 atılır, 10 haneyle sınırlanır.
export function phoneDigits(raw: string): string {
  let d = (raw || "").replace(/\D/g, "");
  if (d.startsWith("90")) d = d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 10);
}

// Input'ta yazarken kademeli grupla: "5514" → "551 4", tam: "5XX XXX XX XX".
export function formatTrPhone(raw: string): string {
  const d = phoneDigits(raw);
  return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean).join(" ");
}

// Geçerli TR cep numarası mı: tam 10 hane ve 5 ile başlıyor.
export function isValidTrPhone(raw: string): boolean {
  const d = phoneDigits(raw);
  return d.length === 10 && d.startsWith("5");
}

// TR cep telefonunu tutarlı göster: baştaki +90/0 at, 10 haneye indir, "5XX XXX XX XX" grupla.
// Eski/bozuk kayıtları (05511310128, boşluklu vb.) display'de normalize eder. Geçersizse ham değeri döndürür.
export function fmtPhone(raw: string | null | undefined): string {
  let d = (raw || "").replace(/\D/g, "");
  if (d.startsWith("90")) d = d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length !== 10) return (raw || "").trim() || "—"; // beklenmedik format: olduğu gibi göster
  return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].join(" ");
}

// Sanitize product text by removing forbidden special characters
// Forbidden: !'^+%&/()=?_-*/![{]}\{½$#££>
export function sanitizeProductText(text: string): string {
  if (!text) return text;
  // Remove forbidden characters: !'^+%&/()=?_-*/![{]}\{½$#££>
  return text.replace(/[!''^+%&/()=?_\-*/!\[\{\]\}\\½$#£>]/g, '').trim();
}
